module.exports = __webpack_public_path__ + "static/media/zen_paper_back.57e31348.png";